<template>
  <v-dialog v-model="modal" width="600px">
    <v-card>
      <v-card-text>
        <v-timeline align-top dense>
          <v-timeline-item
            v-for="observation in comments"
            :key="`obs-${observation.id}`"
            color="primary"
            small
          >
            <v-row class="pt-1">
              <v-col cols="3">
                <strong>{{ observation.date }}</strong>
              </v-col>
              <v-col>
                <strong>{{ observation.user?.name }}</strong>
                <div class="text-caption">
                  <strong>{{ observation.date_formated }}:</strong>
                  {{ observation.comment }}
                </div>
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'Comments',
    props: {
      value: {
        type: Boolean,
        default: true,
      },
      comments: {
        required: true,
        type: Array,
      },
      persistent: Boolean,
    },

    data() {
      return {
        deleteForm: {
          firstReason: '',
          secondReason: '',
        },
      };
    },

    computed: {
      modal: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },
    },
  };
</script>

<style>
  .form-container {
    max-width: 400px;
    margin: auto;
  }
</style>
